import Image from 'next/image';
import LiquidGlass from './liquid-glass';

// Original partner artwork and wording from codexsolutions.io.
const partners = [
  ['partner-01.svg', 'Saman Post'],
  ['partner-02.jpg', 'AMADA'],
  ['partner-03.png', 'Slemani'],
  ['partner-04.jpg', 'Jiyan'],
  ['partner-05.jpg', 'Zalm'],
  ['partner-06.png', 'Zaman Group'],
  ['partner-07.png', 'Avand Home'],
  ['partner-08.png', 'ڕۆیاڵ'],
  ['partner-09.png', 'Violet Organization'],
  ['partner-10.png', 'Glass House'],
  ['partner-11.png', 'Hamwan Home'],
  ['lcq.png', 'LCQ Express'],
  ['pshtiwan.png', 'Pshtiwan Post'],
  ['dhm.png', 'DHM Express'],
  ['b-post.png', 'B-post'],
  ['baw-post.png', 'Baw Post'],
  ['heli-post.png', 'HeliPost'],
];

export default function PartnersSection() {
  return <>
    <section className="chapter partners-chapter" id="partners" aria-labelledby="partners-title">
      <div className="partners-introduction">
        <h2 id="partners-title" className="solutions-portal-title">Clients</h2>
      </div>
    </section>
    <section className="chapter partners-showcase-chapter" id="partners-showcase" aria-labelledby="partners-heading">
      <div className="partners-panel">
        <header className="partners-heading">
          <p className="eyebrow">OUR CLIENTS</p>
          <h2 id="partners-heading">Trusted collaborators and strategic clients</h2>
        </header>
        <ul className="partners-grid" aria-label="Our clients">
          {partners.map(([file, name]) => <li className="partner-tile glass-surface" key={file}>
            <LiquidGlass />
            <Image unoptimized src={`/partners/${file}`} alt={name} width={384} height={384} decoding="async" loading="lazy" />
          </li>)}
        </ul>
      </div>
    </section>
  </>;
}
